var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9EA2A2",
    fillRule: "evenodd",
    d: "M23.235 26.279l-4.466-6.147c2.452-2.091 4.014-5.196 4.014-8.664 0-3.044-1.228-5.97-3.386-8.102a.497.497 0 0 0-.7.035l-.51.561a.495.495 0 0 0 .034.7 9.667 9.667 0 0 1 2.812 6.806c0 5.318-4.325 9.643-9.642 9.643-5.316 0-9.641-4.325-9.641-9.643 0-5.316 4.325-9.641 9.641-9.641A9.65 9.65 0 0 1 15.815 2.9c.237.138.54.059.679-.178l.382-.654a.497.497 0 0 0-.176-.68A11.393 11.393 0 0 0 11.39.076C5.11.077 0 5.187 0 11.468c0 6.282 5.11 11.393 11.391 11.393 2.187 0 4.224-.63 5.96-1.703l4.145 5.704a.497.497 0 0 0 .401.205h.937c.405"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLight);
export default __webpack_public_path__ + "static/media/search-light.5b0c73ad8791ca458b9f3213f530cad6.svg";
export { ForwardRef as ReactComponent };